/**
 * Sales Team Filter
 *
 * Single source of truth for which user titles are considered part of the
 * sales team. Used by SalesRepPage, the Team Leaderboard, and any other
 * gamification display that should be scoped to sales staff only.
 *
 * Extend SALES_TEAM_TITLES to include additional titles that should appear
 * on the Sales Reps page and Team Leaderboard.
 */

// Titles are compared case-insensitively and trimmed.
export const SALES_TEAM_TITLES = ['sales rep', 'sales manager'];

/**
 * Returns true if the given user object has a title that qualifies them as
 * a member of the sales team.
 * @param {object} user - User document with an optional `title` field
 * @returns {boolean}
 */
export function isSalesTeamMember(user) {
  if (!user) return false;
  const t = (user.title || '').trim().toLowerCase();
  return SALES_TEAM_TITLES.includes(t);
}
